module.exports = __webpack_public_path__ + "img/3estrellas.046662e1.png";